import React from 'react';
import NextImage from 'next/legacy/image';
import { useTranslation, Trans } from 'next-i18next';

import type { CacheBlogPost } from '~/services/contentful/model/ContentfulBlogPost';
import {
	Image,
	StyledHeader,
	Title,
	Author as WrittenBy,
} from './Header.styles';

const MAX_HEADER_WIDTH = 700;

const Author = ({ author }: { author: CacheBlogPost['author'] }) => (
	<strong>{author}</strong>
);

const Header = ({ post: { author, coverImage, title } }: Props) => {
	const { t } = useTranslation('blog');

	return (
		<StyledHeader role="banner">
			{coverImage?.dimensions && coverImage?.url ? (
				<NextImage
					alt={coverImage.description}
					height={
						coverImage.dimensions.height *
						(MAX_HEADER_WIDTH / coverImage.dimensions.width)
					}
					src={coverImage.url}
					width={MAX_HEADER_WIDTH}
				/>
			) : (
				<Image alt={coverImage?.description} src={coverImage?.url} />
			)}
			<WrittenBy>
				<Trans
					i18nKey="blog.post.author"
					t={t}
					components={{ author: <Author author={author} key="author" /> }}
				/>
			</WrittenBy>
			<Title>{title}</Title>
		</StyledHeader>
	);
};

type Props = {
	post: CacheBlogPost;
};

export default Header;
